import { useEffect, useState } from "react";
import { TextField, Button, Box, Stack, Chip, Typography } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

function pad(n) { return String(n).padStart(2, "0"); }
function isoLocal(d) { return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; }

function presetThisMonth() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  return { start: isoLocal(start), end: isoLocal(now) };
}
function presetLast(days) {
  const now = new Date();
  const start = new Date(now);
  start.setDate(now.getDate() - days + 1);
  return { start: isoLocal(start), end: isoLocal(now) };
}

export default function DateRangePicker({ value, onChange }) {
  const { t } = useScriptMode();
  const [start, setStart] = useState(value?.start || presetThisMonth().start);
  const [end, setEnd] = useState(value?.end || presetThisMonth().end);

  useEffect(() => {
    if (value?.start && value?.start !== start) setStart(value.start);
    if (value?.end && value?.end !== end) setEnd(value.end);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const invalid = !!start && !!end && start > end;

  const apply = (s, e) => {
    setStart(s);
    setEnd(e);
    if (!(s && e && s > e)) onChange && onChange({ start: s, end: e });
  };

  return (
    <Box display="flex" flexDirection="column" gap={1.5}>
      <Stack direction="row" spacing={1}>
        <Chip
          label={t("manage_stats_preset_this_month")}
          onClick={() => {
            const p = presetThisMonth();
            apply(p.start, p.end);
          }}
        />
        <Chip
          label={t("manage_stats_preset_last_7")}
          onClick={() => {
            const p = presetLast(7);
            apply(p.start, p.end);
          }}
        />
        <Chip
          label={t("manage_stats_preset_last_30")}
          onClick={() => {
            const p = presetLast(30);
            apply(p.start, p.end);
          }}
        />
      </Stack>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
        <TextField
          type="date"
          label={t("manage_stats_range_start")}
          value={start}
          onChange={(e) => setStart(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          type="date"
          label={t("manage_stats_range_end")}
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <Button variant="contained" onClick={() => apply(start, end)} disabled={invalid}>
          {t("manage_detail_save")}
        </Button>
      </Stack>
      {invalid ? (
        <Typography variant="caption" color="error">
          {t("manage_stats_invalid_range")}
        </Typography>
      ) : null}
    </Box>
  );
}
